var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 42.5179,
    height: 42.5179,
    rx: 11.5,
    fill: "#FCF7D7",
    stroke: "#FAF1B9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 11C23.5883 11 25.3093 12.649 25.4297 14.7061L25.4365 14.9365V17.5615C25.4365 18.8085 24.8757 20.9398 23.9707 21.7783C23.9655 21.784 23.8072 21.9586 23.7471 22.0195C23.3809 22.3906 22.8122 23.0476 22.8125 23.7031L22.8135 24.4346L22.8184 25.0137L22.834 25.6631C22.944 28.9181 23.5153 30.7043 25.2744 32.001L11 32L11.6416 28.0557C11.6687 27.8966 11.7863 27.7084 11.9219 27.5938L12.0049 27.5342L18.0625 24.0195C18.1953 23.9431 18.3457 23.7843 18.4355 23.6309L18.4902 23.5176L19.2021 21.9219C18.2568 21.2515 17.6414 19.154 17.5723 17.8066L17.5654 17.5635V14.9385C17.5654 12.7736 19.3362 11 21.5 11ZM28.2852 22.4941C29.5374 23.1516 30.6776 23.5193 32 23.7021L31.998 24.8066L31.9922 25.2939C31.9401 28.6336 31.5371 30.4882 28.4277 31.8477L28.0625 32L27.9238 31.9434C24.3389 30.4645 24.1373 28.4089 24.126 24.4336L24.125 23.7021C25.4474 23.5193 26.5876 23.1516 27.8398 22.4941L28.0625 22.375L28.2852 22.4941ZM30.458 25.1582C30.1828 24.9224 29.769 24.9543 29.5332 25.2295L27.3682 27.7529L26.5576 26.9424L26.4844 26.8789C26.2275 26.6883 25.8629 26.7094 25.6299 26.9424C25.3736 27.1987 25.3736 27.6138 25.6299 27.8701L26.9424 29.1826L27.0127 29.2441C27.2846 29.4481 27.6762 29.4116 27.9043 29.1455L30.5293 26.083L30.5869 26.0049C30.7573 25.7341 30.7082 25.3726 30.458 25.1582Z",
    fill: "#081E56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.c0f87bb2597f692724a993902d2f5e24.svg";
export { ForwardRef as ReactComponent };